import SignUpFooter from "./SignUpFooter";

export default SignUpFooter;